import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";

function MaintenancePage() {
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                textAlign: 'center',
                px: 3
            }}
        >
            <Typography variant="h1" sx={{fontSize: {xs: 72, md: 96}, mb: 2, lineHeight: 1}}>
                🔧
            </Typography>

            <Typography
                variant="h3"
                fontWeight="bold"
                sx={{
                    color: '#2c3e50',
                    mb: 2,
                    fontSize: {xs: '1.8rem', md: '2.5rem'}
                }}
            >
                {t('maintenance.title')}
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    color: '#555',
                    maxWidth: 520,
                    fontSize: {xs: '1rem', md: '1.1rem'},
                    lineHeight: 1.7
                }}
            >
                {t('maintenance.message')}
            </Typography>

            <Box
                sx={{
                    mt: 5,
                    width: 60,
                    height: 4,
                    borderRadius: 2,
                    background: 'linear-gradient(90deg, #5ee197, #0391b0)'
                }}
            />
        </Box>
    );
}

export default MaintenancePage;
